import { Component, type ErrorInfo, type ReactNode } from 'react'

/** A render error in one page shows a panel with the message and a way back,
 *  instead of React unmounting the whole app to a blank screen. Keyed by the
 *  page, so switching tabs starts clean. */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('page crashed:', error, info.componentStack)
  }

  render() {
    if (!this.state.error) return this.props.children
    return (
      <section className="panel">
        <h2>Something went wrong on this page</h2>
        <p className="note small"><code>{this.state.error.message}</code></p>
        <p className="muted small">
          The rest of the app still works.{' '}
          <button type="button" className="linklike" onClick={() => this.setState({ error: null })}>Try again</button>
          {' '}or <button type="button" className="linklike" onClick={() => window.location.reload()}>reload</button>.
        </p>
      </section>
    )
  }
}
